import { computed, observable, makeAutoObservable } from 'mobx';
import { MobxMapAutoNew } from 'src_common/common/mobx-utils/MobxMapAutoNew';
import {
    CarouselModeType,
    HomePageCarouselState,
} from 'src/AppState/CmsState/HomePageCarouselState/HomePageCarouselState';
import { ModelsState } from 'src_common/common/websocket2/ModelsState';
import { GameStore } from 'src/domains/casino/state/AppCasino/store/game-store/Game.store';
import { SdkStaff } from 'src/AppState/sdk/staff';
import { CmsTranslationsState } from 'src/AppState/CmsState/CmsTranslationsState/CmsTranslationsState';
import { CmsTranslationDataModelType } from 'src/api/config/cmsTranslations/getAllCmsTranslations';
import { LanguagesState } from 'src/AppState/CmsState/LanguagesState/LanguagesState';
import { CmsDisplayOrderState } from 'src/AppState/CmsState/CmsDisplayOrderState/CmsDisplayOrderState';
import { TrpcClient } from 'src/AppState/TrpcClient';
import { Common } from 'src/AppState/Common';

export const promoCarouselComponentType = 'promo-carousel';

export class CarouselMainState {
    private readonly carouselStateMap: MobxMapAutoNew<CarouselModeType, HomePageCarouselState>;
    @observable public carouselMode: CarouselModeType;

    public constructor(
        public readonly casinoManagementState: GameStore,
        modelsState: ModelsState,
        sdkStaff: SdkStaff,
        public readonly cmsTranslations: CmsTranslationsState,
        public readonly languagesState: LanguagesState,
        public readonly cmsDisplayOrderState: CmsDisplayOrderState,
        private readonly trpcClient: TrpcClient,
        private readonly common: Common
    ) {
        this.carouselMode = 'homepage';

        this.carouselStateMap = new MobxMapAutoNew(
            (carouselMode: CarouselModeType): HomePageCarouselState =>
                new HomePageCarouselState(
                    carouselMode,
                    modelsState,
                    sdkStaff,
                    cmsTranslations,
                    languagesState,
                    cmsDisplayOrderState,
                    this.trpcClient,
                    this.common
                )
        );
        makeAutoObservable(this);
    }

    @computed public get cmsTranslationsPromoCarouselList(): Array<CmsTranslationDataModelType> {
        return this.cmsTranslations.cmsTranslationsList.filter(
            (item) => item.component_type === `${promoCarouselComponentType}-${this.carouselMode}`
        );
    }

    @computed public get carouselStateItem(): HomePageCarouselState {
        return this.carouselStateMap.get(this.carouselMode);
    }

    public onChangeCarouselMode = (mode: CarouselModeType): void => {
        this.carouselMode = mode;
        this.carouselStateItem.resetAllTranslationForms();
    };
}
